import React, { useEffect, useState } from 'react';
import axios from 'axios';
import {
  Container,
  Typography,
  Box,
  TextField,
  Button,
  Select,
  MenuItem,
  InputLabel,
  FormControl,
  Alert,
  IconButton
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { CircularProgress } from '@mui/material';

const CreateDirectory = ({ editData, onClose, onSuccess }) => {
  const [formData, setFormData] = useState({
    type: '',
    name: '',
    location: '',
    info: '',
    keywords: '',
    website: '',
    email: '',
  });
  const isEdit = !!editData;

  const [message, setMessage] = useState({ type: '', text: '' });
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    if (editData) {
      setFormData({
        type: editData.type || '',
        name: editData.name || '',
        location: editData.location || '',
        info: editData.info || '',
        keywords: Array.isArray(editData.keywords) ? editData.keywords.join(', ') : editData.keywords || '',
        website: editData.website || '',
        email: editData.email || '',
      });
    }
  }, [editData]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const keywordsArray = formData.keywords.split(',').map((k) => k.trim());
    try {
      // const response = await axios.post(`${process.env.REACT_APP_BACKEND_URL}/api/directory/create`, {
      //   ...formData,
      //   keywords: keywordsArray,
      // });
      // if (response.data.success) {
      //   setMessage({ type: 'success', text: 'Directory created successfully!' });
      //   setFormData({
      //     type: '',
      //     name: '',
      //     location: '',
      //     info: '',
      //     keywords: '',
      //     website: '',
      //     email: '',
      //   });
      setIsLoading(true)

      const url = isEdit
        ? `${process.env.REACT_APP_BACKEND_URL}/api/directory/${editData._id}`
        : `${process.env.REACT_APP_BACKEND_URL}/api/directory/create`;

      const method = isEdit ? axios.put : axios.post;

      const response = await method(url, {
        ...formData,
        keywords: keywordsArray,
      });
      setIsLoading(false)

      if (response.data.success) {
        setMessage({ type: 'success', text: isEdit ? 'Directory updated!' : 'Directory created!' });
        setFormData({
          type: '',
          name: '',
          location: '',
          info: '',
          keywords: '',
          website: '',
          email: '',
        });
        if (isEdit) {
          onSuccess();
          onClose();
        }
      } else {
        setMessage({ type: 'error', text: 'Failed to create directory entry.' });
      }
    } catch (error) {
      console.error('Error creating directory:', error);
      setMessage({ type: 'error', text: 'Error occurred. Please try again.' });
      setIsLoading(false)
    }
  };

  const handleDelete = async () => {
    if (!editData?._id) return;

    const confirmed = window.confirm("Are you sure you want to delete this directory?");
    if (!confirmed) return;

    try {
      setIsLoading(true);
      const response = await axios.delete(`${process.env.REACT_APP_BACKEND_URL}/api/directory/${editData._id}`);

      if (response.data.success) {
        setIsLoading(false)
        setMessage({ type: 'success', text: 'Directory deleted successfully!' });
        onSuccess();
        onClose();
        
      } else {
        setMessage({ type: 'error', text: 'Failed to delete directory.' });
        setIsLoading(false)
      }
    } catch (error) {
      console.error("Error deleting directory:", error);
      setMessage({ type: 'error', text: 'Error occurred while deleting.' });
      setIsLoading(false)
    }
  };

  if (isLoading) {
    return (
      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '200px' }}>
        <CircularProgress />
      </div>
    );
  }


  return (
    <Container maxWidth="sm" sx={{ mt: 4 }}>
      {/* <Typography variant="h4" gutterBottom align="center">
        Create Directory
      </Typography>

      {isEdit && (
        <Button onClick={onClose} sx={{ mt: 2 }} color="secondary">
          Cancel
        </Button>
      )} */}

      <Box display="flex" justifyContent="space-between" alignItems="center">
        <Typography variant="h4" gutterBottom>
          {isEdit ? "Update Directory" : "Create Directory"}
        </Typography>

        {isEdit && (
          <IconButton onClick={onClose} color="secondary" aria-label="cancel">
            <CloseIcon />
          </IconButton>
        )}
      </Box>

      {message.text && (
        <Alert severity={message.type} sx={{ mb: 2 }}>
          {message.text}
        </Alert>
      )}

      <Box
        component="form"
        onSubmit={handleSubmit}
        sx={{
          display: 'flex',
          flexDirection: 'column',
          gap: 2,
          p: 3,
          border: '1px solid #ccc',
          borderRadius: 2,
          boxShadow: 2,
          backgroundColor: '#f9f9f9',
        }}
      >
        <FormControl fullWidth required>
          <InputLabel>Type</InputLabel>
          <Select name="type" value={formData.type} onChange={handleChange} label="Type">
            <MenuItem value="Business">Business</MenuItem>
            <MenuItem value="Church Lodges">Church Lodges</MenuItem>
            <MenuItem value="Natural Healers">Natural Healers</MenuItem>
          </Select>
        </FormControl>

        <TextField
          name="name"
          label="Name"
          value={formData.name}
          onChange={handleChange}
          required
        />

        <TextField
          name="location"
          label="Location"
          value={formData.location}
          onChange={handleChange}
        />

        <TextField
          name="info"
          label="Info"
          multiline
          rows={3}
          value={formData.info}
          onChange={handleChange}
        />

        <TextField
          name="keywords"
          label="Keywords (comma separated)"
          value={formData.keywords}
          onChange={handleChange}
        />

        <TextField
          name="website"
          label="Website"
          value={formData.website}
          onChange={handleChange}
        />

        <TextField
          name="email"
          label="Email"
          type="email"
          value={formData.email}
          onChange={handleChange}
        />

        <Button variant="contained" color="primary" type="submit">
          {isEdit ? "Update Directory" : "Create Directory"}
        </Button>
        {isEdit && (
          <Button
            variant="contained"
            color="error"
            onClick={handleDelete}
            type="button"
          >
            Delete Directory
          </Button>
        )}

      </Box>
    </Container>
  );
};

export default CreateDirectory;
